import moment from "moment";
import { toast } from "react-toastify";

export function formatPhoneNumber(phoneNumberString, country, countryCode) {

  if (phoneNumberString && country && (country === "United Kingdom" || country === "United States" || country === "Canada")) {
    let phoneReg = /^(1|)?(\d{3})(\d{3})(\d{4})$/;
    if (country === "United Kingdom") {
      phoneReg = /^(44|)?(\d{4})(\d{6})$/;
    }
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(phoneReg);
    if (match) {
      const intlCode = (country === "United Kingdom" ? '+44 ' : '+1 ');

      let phFormat = [intlCode, '(', match[2], ') ', match[3], '-', match[4]];
      if (country === "United Kingdom") {
        phFormat = [intlCode, match[2], ' ', match[3]];
      } else if (country === "Canada") {
        phFormat = [intlCode, match[2], ' ', match[3], ' ', match[4]];
      }
      return phFormat.join('');
    }
  } else if (phoneNumberString && countryCode) {
    return `+${countryCode} ${phoneNumberString}`
  } else if (phoneNumberString) {
    return phoneNumberString
  } else {
    return null;
  }


}

export function unformatPhoneNumber(phoneNumberString, country, phoneCode) {
  // console.log('unformatPhoneNumber', phoneNumberString, country, phoneCode)

  if (phoneCode) {
    let formatedPhoneNumber = phoneNumberString.replace('+1', '');
    return formatedPhoneNumber.replace(`+${phoneCode}`, '')
  } else {
    return phoneNumberString.replace('+1', '')
  }
}


export function getComponentActionList(component = "") {
  const userObject = window.sessionStorage.getItem('userDetails');
  const userData = JSON.parse(userObject);
  const rolesObject = userData.roleAccess;
  // console.log(rolesObject)
  let actionsArray = [];
  let indexObject = rolesObject?.pages.filter((item) => { return item.component === component });
  let allowedActions = indexObject && indexObject.length > 0 ? indexObject[0].actions : [];
  allowedActions.forEach(element => {
    if (element.role_is_active) {
      actionsArray.push(element.action);
    } 
    else {
        if ((userData?.roleId === 10) && (element.action == 'update_invoice_details')) {
           actionsArray.push(element.action);
      }
    }
  });
  return actionsArray;
};

export function getComponentViewsList(component = "") {
  const userObject = window.sessionStorage.getItem('userDetails');
  const userData = JSON.parse(userObject);
  const rolesObject = userData.roleAccess;
  let actionsArray = [];
  let allowedActions = [];
  let indexObject = rolesObject?.pages.filter((item) => { return item.component === component });
  allowedActions = indexObject && indexObject.length > 0 ? indexObject[0]?.views ? indexObject[0]?.views : [] : [];
  allowedActions.forEach(element => {
    if (element.role_is_active) {
      actionsArray.push(element.action);
    }
  });
  return actionsArray;
};

export function isActionAllowed(actionsArray, actionUrl = "") {
  return actionsArray.indexOf(actionUrl) >= 0 ? true : false;
};

export const showErrorToast = (error) => {
  const errorMsg = error?.response?.data?.message || error || "Something went wrong";
  return toast(errorMsg, {
    autoClose: 5000,
    type: toast.TYPE.ERROR,
    position: toast.POSITION.BOTTOM_CENTER,
  });
};

export const showSuccessToast = (successMsg) => {
  toast(successMsg, {
    autoClose: 5000,
    type: toast.TYPE.SUCCESS,
    position: toast.POSITION.BOTTOM_CENTER,
  });
};

export const showWarningToast = (warningMsg) => {
  toast(warningMsg, {
    autoClose: 7000,
    type: toast.TYPE.WARNING,
    position: toast.POSITION.TOP_RIGHT,
  });
};

export const getCustomLabel = (defaultKeyName, fallback) => {
  try {
    const stored = sessionStorage.getItem("customLabelSettings");
    if (stored) {
      const obj = JSON.parse(stored);
      const customKey = defaultKeyName.replace(/^default_/, "custom_");
      return obj[customKey] || obj[defaultKeyName] || fallback;
    }
  } catch (e) {
  }
  return fallback;
};

export const setCustomLabels = (obj) => {
  try {
    sessionStorage.setItem("customLabelSettings", JSON.stringify(obj));
    try {
      window.dispatchEvent(new Event("customLabelsUpdated"));
    } catch (e) {}
  } catch (e) {}
};

export const removeSpecialChar = (value) => {
  value = value.replace(/[&\/\\#,+!@^&()$~%.'":;-?<>{}]/g, "");
  value = value.replaceAll("-", "");
  return value.trim();
}

export const formatDate = (value, format = "MM/DD/YYYY", isUtc = true) => {
  return isUtc
    ? moment.utc(value).format(format)
    : moment(value).format(format);
};
export const expiryDate = (value, format = "MM/DD/YYYY HH:mm:ss", isUtc = true) => {
  return isUtc
    ? moment.utc(value).format(format)
    : moment(value).format(format);
};

export const replaceNullValues = function (obj) {
  if (Array.isArray(obj)) {
    return obj.map(replaceNullValues); // Recursively handle arrays
  } else if (obj !== null && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, replaceNullValues(value)])
    );
  }
  return obj === null ? "" : obj; // Replace null with an empty string
}

export const isTwoAddressSame = (inputObj, dbDataObj, type, billingCountryCode, shippingCountryCode) => {
  let isChanged = false;
  const input = replaceNullValues(inputObj);
  const dbData = replaceNullValues(dbDataObj);
  if (type === "shipping") {
    if (
      (dbData.businessname && dbData.businessname.toLowerCase()) !==
      (input.shippingToBusinessName &&
        input.shippingToBusinessName.toLowerCase()) ||
      (dbData.address1 && dbData.address1.toLowerCase()) !==
      (input.shippingToAddressLine1 &&
        input.shippingToAddressLine1.toLowerCase()) ||
      (dbData.address2 && dbData.address2.toLowerCase()) !==
      (input.shippingToAddressLine2
        ? input.shippingToAddressLine2 &&
        input.shippingToAddressLine2.toLowerCase()
        : "") ||
      (dbData.city && dbData.city.toLowerCase()) !==
      (input.shippingToCity && input.shippingToCity.toLowerCase()) ||
      (dbData.states && dbData.states.toLowerCase()) !==
      (input.shippingToState && input.shippingToState.toLowerCase()) ||
      (dbData.country && dbData.country === "" && input.shippingToCountry.toLowerCase() !== 'united states') ||
      (dbData.country && dbData.country !== "" && (dbData.country.toLowerCase() !== input.shippingToCountry.toLowerCase())) ||
      (dbData.country && dbData.country.toLowerCase()) !==
      (input.shippingToCountry && input.shippingToCountry.toLowerCase()) ||
      (dbData.zipcode && dbData.zipcode.toLowerCase()) !==
      (input.shippingToZip && input.shippingToZip.toLowerCase()) ||
      (dbData.countrycode === "" && shippingCountryCode !== '+1') ||
      (dbData.countrycode !== "" && (dbData.countrycode !== shippingCountryCode))
    ) {
      isChanged = true;
    }
    return isChanged;
  } else {
    if (
      (dbData.businessname && dbData.businessname.toLowerCase()) !==
      (input.billingToBusinessName &&
        input.billingToBusinessName.toLowerCase()) ||
      (dbData.address1 && dbData.address1.toLowerCase()) !==
      (input.billingToAddressLine1 &&
        input.billingToAddressLine1.toLowerCase()) ||
      (dbData.address2 && dbData.address2.toLowerCase()) !==
      (input.billingToAddressLine2 &&
        input.billingToAddressLine2.toLowerCase()) ||
      (dbData.city && dbData.city.toLowerCase()) !==
      (input.billingToCity && input.billingToCity.toLowerCase()) ||
      (dbData.states && dbData.states.toLowerCase()) !==
      (input.billingToState && input.billingToState.toLowerCase()) ||
      (dbData.country && dbData.country === "" && input.billingToCountry.toLowerCase() !== 'united states') ||
      (dbData.country && dbData.country !== "" && (dbData.country.toLowerCase() !== input.billingToCountry.toLowerCase())) ||
      (dbData.zipcode && dbData.zipcode.toLowerCase()) !==
      (input.billingToZip && input.billingToZip.toLowerCase()) ||
      (dbData.countrycode === "" && billingCountryCode !== '+1') ||
      (dbData.countrycode !== "" && (dbData.countrycode !== billingCountryCode))
    ) {
      isChanged = true;
    }
    return isChanged;
  }
};

export const typeFilter = [
  {
      id: "standand_and_misc",
      value: "Standard and Misc Watch"
  },
  {
      id: "standard_watch",
      value: "Standard Watch"
  },
  {
      id: "misc_watch",
      value: "Misc Watch"
  },
  {
      id: "misc_product",
      value: "Misc Product"
  }
]

export const inventoryStatusFilter = [
  { id: "2", value: "Incoming" },
  { id: "6", value: "Needs Service / Polish" },
  { id: "7", value: "At Service" },
  { id: "11", value: "Intake Complete" },
  { id: "13", value: "Need to Post" },
  { id: "12", value: "Invoiced" },
  { id: "1", value: "Inhand" },
  { id: "3", value: "Out on Memo" },
  { id: "4", value: "On Hold / Reserved" },
  { id: "8", value: "Need to Ship" },
  { id: "9", value: "Shipped waiting on payment" },
  { id: "10", value: "Sold & Cashed Out" },
  { id: "5", value: "Available to Order" },
];
export const renderInventoryStatusLabel = (statusId, lookupOrLabel) => {
  const label =
    typeof lookupOrLabel === "string"
      ? lookupOrLabel
      : lookupOrLabel?.[statusId] ?? lookupOrLabel?.[String(statusId)];
  return label || "--";
};

 export const soldStatusFilter = [
  { id: "0", value: "Unsold" },
  { id: "1", value: "Sold" },
  { id: "ALL", value: "All" },
  { id: "Void", value: "Void" },
 ]

 export const invoiceStatusFilter = [
  { id: "ALL", value: "All" },
  { id: "paid", value: "Paid" },
  { id: "notPaid", value: "Not Paid" },
 ]

 export const inventoryTypeFilter = [
  { id: "ALL", value: "All" },
  { id: "1", value: "Regular Inventory" },
  { id: "2", value: "Memo Inventory" },
  { id: "3", value: "Partnership Inventory" },
  { id: "4", value: "Trade Inventory" },
  { id: "5", value: "Consignment Inventory" },
  { id: "NULL", value: "Not Assigned" },
 ]

 export const categoryFilter = [
  { id: "ALL", value: "All" },
  { id: "watch related accessories", value: "Watch Related Accessories" },
  { id: "apparel", value: "Apparel" },
  { id: "watch parts", value: "Watch Part (s)" },
  { id: "jewelry", value: "Jewelry" },
  { id: "stones", value: "Stones" },
  { id: "hand bags", value: "Hand Bags" },
  { id: "wallets", value: "Wallets" },
  { id: "bag related accessories", value: "Bag Related Accessories" },
  { id: "service watches", value: "Service Watches" },
  { id: "others", value: "Others" },
];

export const getInventoryTileFields  = () => [
  { id: "inventoryid", value: "Inventory ID" },
  { id: "modelnumber", value: "Watch Model Number" },
  { id: "modelname", value: "Watch Model Name" },
  { id: "serialno", value: "Serial Number" },
  { id: "condition", value: "Condition" },
  { id: "publicdealernote", value: "Public Dealer Note" },
  { id: "wholesaleprice", value: getCustomLabel("custom_wholesale_price", "Target Wholesale Price") },
  { id: "retailprice", value: getCustomLabel("custom_end_customer_price", "Target Retail Price") },
  { id: "retailwireprice", value: getCustomLabel("custom_end_customer_wire_price", "Target Retail Wire Price") },
  { id: "warrantybox", value: "I Have A Box" },
  { id: "warrantypaper", value: "Warranty Paper" },
  { id: "warrantydate", value: "Warranty Date" },
  { id: "purchaseprice", value: "Purchase Price" },
  { id: "purchase_expense", value: "Purchase Expense" },
  { id: "total_cost", value: "Total Cost" },
  { id: "brandname", value: "Brand Name" },
  { id: "casematerial", value: "Case Material" },
  { id: "casesize", value: "Case Size" },
  { id: "dialcolor", value: "Dial Color" },
  { id: "bandmaterial", value: "Band Material" },
  { id: "inventory_title", value: "Inventory Title Item" },
  { id: "purchasefrom", value: "Purchased From" },
  { id: "purchasedate", value: "Purchased Date" },
  { id: "purchase_invoice_paid", value: "Purchase Payment Status" },
  { id: "purchase_payment_date", value: "Purchase Payment Date" },
  { id: "purchase_payment_details", value: "Purchase Payment Details" },
  { id: "purchase_expense_note", value: "Purchase Expense Note" },
  { id: "inventorytype", value: "Inventory Type" },
  { id: "inventory_status", value: "Inventory Status" },
  { id: "inventory_location", value: "Inventory Location" },
  { id: "bandsize", value: "Band Size" },
  { id: "links", value: "Number Of Links" },
  { id: "tag_price", value: getCustomLabel("custom_tag_price", "Tag Price") },
  { id: "sold_price", value: "Sold Price" },
  { id: "note", value: "Internal Dealer Note" },
  { id: "ismodified", value: "Modified" },
  { id: "is_include_dealerfeed", value: "Include Dealer Feed" },
  { id: "manufactureprice", value: "Last Updated MSRP" },
];